define(['backbone', 'modules/connectionsOld/models/base'], (Backbone, BaseConnection) => BaseConnection.extend({
    urlRoot: '/connections',

    defaults: {
        id: null,
        account_id: null,
        parent_id: null,
        descriptive_name: null,
        customer_xid: null,
        status: null,
        currency_id: null
    },

    nested: {
        params: Backbone.Model
    }
}));
